/* import __COLOCATED_TEMPLATE__ from './fin-identity.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type { PulseAccordion } from 'glint/pulse';
import type RouterService from '@ember/routing/router-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import type Platform from 'embercom/objects/standalone/platforms/platform';

export interface Args {
  accordion: PulseAccordion;
  closeAccordion: () => void;
}

export default class FinIdentity extends Component<Args> {
  @service declare router: RouterService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: {
    app: { canUseMBFAiAgentIdentities: boolean; hasStandalonePlatform(name: string): boolean };
    mainStandalonePlatform: Platform;
  };

  get isIncomplete() {
    return !this.finStandaloneService.operatorIdentity;
  }

  get shouldShowSimplifiedDesign() {
    return this.appService.app.canUseMBFAiAgentIdentities;
  }

  get zendeskMessagingUrl() {
    return this.router.urlFor('apps.app.standalone.deploy.zendesk.messaging.integrate', {
      queryParams: {
        section: this.standalonePlatform.isConnected ? 'zendesk-setup-fin-messenger-identity' : '',
      },
    });
  }

  get ticketsSetupUrl() {
    return this.router.urlFor('apps.app.standalone.deploy.zendesk.tickets.integrate', {
      queryParams: {
        section: 'fin-messenger-identity',
      },
    });
  }

  get standalonePlatform() {
    return this.appService.mainStandalonePlatform;
  }

  get translationKey() {
    return `standalone.intercom-messenger.deploy.integrate.fin-identity.${this.standalonePlatform.platformKey}`;
  }

  @action async saveOperatorIdentity() {
    await this.finStandaloneService.updateOperatorIdentity();
    this.args.closeAccordion();
  }

  @action goToMessengerSettings() {
    safeWindowOpen(this.router.urlFor('apps.app.settings.channels.messenger.general'), '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::IntercomMessenger::Deploy::Integrate::FinIdentity': typeof FinIdentity;
    'standalone/intercom-messenger/deploy/integrate/fin-identity': typeof FinIdentity;
  }
}
